module.exports = __webpack_public_path__ + "static/media/24.1bea713e.png";